// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_jge","cls2":"TransactionalPricingModal-cls2_0Mb TransactionalPricingModal-cls1_jge"};